import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RecordTitle } from '@app/models/record.model';
import { RecordSelectComponent } from './record-select.component';

@Component({
  selector: 'app-record-select-modal-component',
  template: `<app-record-select
    (selectedChange)="select($event)"
    (onCloseChange)="close()"
  ></app-record-select>`,
})
export class RecordSelectModalComponent {
  constructor(public dialogRef: MatDialogRef<RecordSelectComponent>) {}

  select(selected: RecordTitle[]) {
    this.dialogRef.close(selected);
  }

  close() {
    this.dialogRef.close();
  }
}
